/* eslint-disable react/jsx-props-no-spreading */

import { withTheme } from '@emotion/react'
import { color as colorStyled, layout, space } from 'styled-system'
import css from '@styled-system/css'
import styled from '@emotion/styled'
import { Box } from 'components/layout/box'
import { global } from '../../../themes'
import { IconComponentProps } from './icon.types'

export const iconSymbols = [
  'API',
  'add',
  'add-user',
  'adjustment',
  'alert',
  'alert-fill',
  'analytics',
  'array',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'attach',
  'bold',
  'bookmark',
  'boolean',
  'brackets',
  'branch',
  'calendar',
  'card',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'caret-up-down',
  'certificate',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clock',
  'close',
  'close-circle',
  'cloud',
  'code',
  'comment',
  'commit',
  'compare',
  'copy',
  'danger',
  'dashboard',
  'database',
  'decode',
  'different',
  'document',
  'drag',
  'duplicate',
  'edit',
  'encode',
  'envelope',
  'environment',
  'equal',
  'exist',
  'extension',
  'eye',
  'eye-false',
  'filter',
  'folder',
  'fork',
  'funnel',
  'gateway',
  'get',
  'globe',
  'greater',
  'help',
  'history',
  'home',
  'info',
  'info-fill',
  'italic',
  'key',
  'less',
  'link',
  'list',
  'location',
  'lock',
  'luckymarmot',
  'map',
  'marketplace',
  'menu',
  'merge',
  'money',
  'more-vertical',
  'network',
  'notification',
  'null',
  'num',
  'object',
  'order',
  'paw',
  'performance',
  'picture',
  'play',
  'pull-request',
  'put',
  'quote',
  'redo',
  'refresh',
  'restart',
  'search',
  'secure',
  'send',
  'settings',
  'share',
  'sidebar-hide',
  'sidebar-show',
  'sort',
  'spinner',
  'star',
  'strikethrough',
  'string',
  'subtract',
  'success-fill',
  'tag',
  'team',
  'terminal',
  'test',
  'theme-dark',
  'theme-light',
  'thumb-down',
  'thumb-up',
  'transaction',
  'trash',
  'twitter',
  'undo',
  'unlock',
  'unordered-list',
  'unsecure',
  'updates',
  'user',
  'variable',
  'version',
  'workspace',
]

const Svg = withTheme(
  styled.svg(
    ({ color = 'texts.highEmphasis' }) =>
      css({
        display: 'inline-block',
        verticalAlign: 'middle',
        color,
      }),
    colorStyled,
    layout,
    space,
  ),
)

export const Icon: React.FC<IconComponentProps> = ({
  display = 'inline-flex',
  symbol = 'paw',
  color = undefined,
  size = 16,
  minWidth = 'auto',
  iconPath = global.iconPath,
  iconProps,
  ...other
}) => (
  <Box minWidth={minWidth} display={display} {...other}>
    <Svg
      width={size}
      height={size}
      color={color}
      symbol={symbol}
      {...iconProps}
    >
      <use xlinkHref={`${iconPath}#${symbol}`} />
    </Svg>
  </Box>
)

export default Icon
